import RestClient from '../../config/rest-client';

export async function getSlider(id) {
  try {
    const data = await RestClient.findOne('sliders/view', id);
    return data;
  } catch (error) {
    return {
      sliders: []
    }
  }
}